import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useSupabaseAuth } from '@/hooks/useSupabaseAuth';

export const useBrokerAccess = () => {
  const { user, status } = useSupabaseAuth();

  const query = useQuery({
    queryKey: ['broker-access-v2', user?.id],
    queryFn: async () => {
      if (!user?.id) return { only: false, has: false };
      const { data, error } = await supabase
        .from('user_network_roles')
        .select('role')
        .eq('user_id', user.id)
        .eq('is_active', true);
      if (error) throw error;
      const rows = data ?? [];
      const has = rows.some((item) => item.role === 'BROKER_PARTNER');
      return { only: has && rows.every((item) => item.role === 'BROKER_PARTNER'), has };
    },
    enabled: status === 'authenticated' && !!user?.id,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isBrokerOnly: query.data?.only === true,
    hasBrokerAccess: query.data?.has === true,
    isError: query.isError,
    refetch: query.refetch,
    isLoading: status === 'booting' || (status === 'authenticated' && query.isLoading),
  };
};